export interface SupportContact {
  phone: string | null;
  email: string | null;
}

export function useSupportContact(): SupportContact {
  const config = useRuntimeConfig();

  return {
    phone: config.public.supportPhone as string | null,
    email: config.public.supportEmail as string | null
  };
}
